// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerContent":"Footer_footerContent__GLsTv","footerNav":"Footer_footerNav__oMKFP","footerText":"Footer_footerText__rlW5Y"};